/**
 * Purchase Orders UI types — backend rows are mapped here by the page adapter.
 * Low-stock suggestions are derived client-side from the SKUs store.
 */

export type POStatus = 'draft' | 'pending_approval' | 'approved' | 'sent' | 'transit' | 'partial' | 'delayed' | 'done';

export interface PurchaseOrder {
  id: string;
  poNumber: string;
  vendor: string;
  warehouse: string;
  created: string;
  expected: string;
  items: number;
  total: number;
  progress: number;
  status: POStatus;
  /** Backend status, kept alongside the 6/8-bucket UI status for approve/reject actions. */
  backendStatus: string;
}

export interface LowStockItem {
  id: string;
  name: string;
  sku: string;
  currentStock: number;
  reorderPoint: number;
  suggestedQty: number;
}

export interface POStatData {
  id: string;
  title: string;
  subtitle: string;
  value: string;
  color: 'blue' | 'yellow' | 'orange' | 'red' | 'green';
}

/**
 * Maps backend purchase_order status to the UI's bucket model.
 * 'received' → 'done', 'sent' stays 'sent', 'partial' stays 'partial',
 * 'cancelled' is shown as 'delayed' (no UI bucket for cancelled).
 * 'pending_approval' and 'approved' (VP-ADM-003) get their own buckets so an
 * Admin can see — and act on — POs awaiting sign-off before dispatch.
 */
export function backendStatusToUi(status: string): POStatus {
  switch (status) {
    case 'draft': return 'draft';
    case 'pending_approval': return 'pending_approval';
    case 'approved': return 'approved';
    case 'sent': return 'sent';
    case 'partial': return 'partial';
    case 'received': return 'done';
    case 'cancelled': return 'delayed';
    default: return 'draft';
  }
}
